import React, { useState } from 'react';
import axios from 'axios';

function Register() {
    const [formData, setFormData] = useState({ username: 'shiva', email: '', password: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('https://nsureback.asianspinehospital.com/register', formData);
            alert(response.data.message);
        } catch (error) {
            alert(error.response.data.message || 'Error registering user.');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <input type="text" minLength={3} required placeholder="Username" value={formData.username}
                onChange={e => setFormData({ ...formData, username: e.target.value })} />
            <input type="email" minLength={3} required placeholder="Email" value={formData.email}
                onChange={e => setFormData({ ...formData, email: e.target.value })} />
            <input type="password" minLength={8} maxLength={12} required placeholder="Password" value={formData.password}
                onChange={e => setFormData({ ...formData, password: e.target.value })} />
            <button type="submit">Register</button>
        </form>
    );
}

export default Register;
